import React from 'react';
import { BarChart3, MapPin, Users, TrendingUp, Factory, Building2, Plane, Package } from 'lucide-react';

const PerfilYucatan = () => {
  const [selectedYear, setSelectedYear] = React.useState('2025');
  
  const indicadoresPorAno = {
    '2025': [
      { trimestre: 'T1', nombre: 'Indicadores Económicos T1 2025', fecha: 'Enero - Marzo 2025', tamano: '2.4 MB' },
      { trimestre: 'T2', nombre: 'Indicadores Económicos T2 2025', fecha: 'Abril - Junio 2025', tamano: '2.3 MB' }
    ],
    '2024': [
      { trimestre: 'T1', nombre: 'Indicadores Económicos T1 2024', fecha: 'Enero - Marzo 2024', tamano: '2.5 MB' },
      { trimestre: 'T2', nombre: 'Indicadores Económicos T2 2024', fecha: 'Abril - Junio 2024', tamano: '2.6 MB' },
      { trimestre: 'T3', nombre: 'Indicadores Económicos T3 2024', fecha: 'Julio - Septiembre 2024', tamano: '2.4 MB' },
      { trimestre: 'T4', nombre: 'Indicadores Económicos T4 2024', fecha: 'Octubre - Diciembre 2024', tamano: '2.7 MB' }
    ],
    '2023': [
      { trimestre: 'T1', nombre: 'Indicadores Económicos T1 2023', fecha: 'Enero - Marzo 2023', tamano: '2.3 MB' },
      { trimestre: 'T2', nombre: 'Indicadores Económicos T2 2023', fecha: 'Abril - Junio 2023', tamano: '2.5 MB' },
      { trimestre: 'T3', nombre: 'Indicadores Económicos T3 2023', fecha: 'Julio - Septiembre 2023', tamano: '2.4 MB' },
      { trimestre: 'T4', nombre: 'Indicadores Económicos T4 2023', fecha: 'Octubre - Diciembre 2023', tamano: '2.6 MB' }
    ]
  };

  const estadisticas = [
    { valor: '2.3M', label: 'Población Total', icono: Users, color: 'from-[#8B1538] to-[#6B0F2A]' },
    { valor: '43,379', label: 'km² Superficie', icono: MapPin, color: 'from-[#8B1538] to-[#6B0F2A]' },
    { valor: '106', label: 'Municipios', icono: Building2, color: 'from-[#8B1538] to-[#6B0F2A]' },
    { valor: '4.2%', label: 'Crecimiento PIB', icono: TrendingUp, color: 'from-[#8B1538] to-[#6B0F2A]' }
  ];

  const sectoresEconomicos = [
    {
      nombre: 'Turismo',
      porcentaje: 35,
      icono: Plane,
      descripcion: 'Principal motor económico con sitios arqueológicos y playas'
    },
    {
      nombre: 'Manufactura',
      porcentaje: 28,
      icono: Factory,
      descripcion: 'Industria automotriz, textil y de alimentos'
    },
    {
      nombre: 'Comercio',
      porcentaje: 22,
      icono: Package,
      descripcion: 'Comercio local e internacional en expansión'
    },
    {
      nombre: 'Servicios',
      porcentaje: 15,
      icono: Building2,
      descripcion: 'Servicios profesionales y tecnológicos'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=1920&q=80" 
            alt="Perfil de Yucatán"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h1 className="text-5xl font-bold text-white mb-4">Perfil de Yucatán</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Descubre los datos, estadísticas y características que definen a nuestro estado.
          </p>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Yucatán en Cifras */}
        <section id="yucatan-cifras" className="mb-20 scroll-mt-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Yucatán en Cifras</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Consulta y descarga los indicadores económicos trimestrales del estado de Yucatán
            </p>
          </div>

          <div className="bg-white rounded-xl border border-gray-200 shadow-lg p-8">
            {/* Year Selector */}
            <div className="flex justify-center gap-4 mb-8">
              {Object.keys(indicadoresPorAno).map((year) => (
                <button
                  key={year}
                  onClick={() => setSelectedYear(year)}
                  className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                    selectedYear === year
                      ? 'bg-[#8B1538] text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {year}
                </button>
              ))}
            </div>

            {/* Trimestre Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {indicadoresPorAno[selectedYear].map((indicador, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-6 border border-gray-200 hover:shadow-lg transition-all duration-300"
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center">
                      <span className="text-white font-bold text-lg">{indicador.trimestre}</span>
                    </div>
                    <span className="text-xs text-gray-500">{indicador.tamano}</span>
                  </div>
                  
                  <h3 className="font-semibold text-gray-900 mb-2 text-sm">{indicador.nombre}</h3>
                  <p className="text-xs text-gray-600 mb-4">{indicador.fecha}</p>
                  
                  <button className="w-full px-4 py-2 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium text-sm flex items-center justify-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Descargar PDF
                  </button>
                </div>
              ))}
            </div>

            {/* Info Note */}
            <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-gray-700">
                <strong>Nota:</strong> Los indicadores incluyen datos sobre PIB estatal, inversión extranjera directa, 
                empleo formal, exportaciones, turismo y otros indicadores clave del desarrollo económico de Yucatán.
              </p>
            </div>
          </div>
        </section>

        {/* Localización */}
        <section id="localizacion" className="mb-20 scroll-mt-24">
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-8 lg:p-12">
                <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                  <MapPin className="h-7 w-7 text-white" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Localización</h2>
                <div className="space-y-4 text-gray-600">
                  <p>
                    <strong className="text-gray-900">Ubicación:</strong> Sureste de México, en la península de Yucatán
                  </p>
                  <p>
                    <strong className="text-gray-900">Límites:</strong>
                  </p>
                  <ul className="ml-6 space-y-2">
                    <li>• Norte: Golfo de México</li>
                    <li>• Este: Estado de Quintana Roo</li>
                    <li>• Oeste: Estado de Campeche</li>
                  </ul>
                  <p>
                    <strong className="text-gray-900">Capital:</strong> Mérida
                  </p>
                  <p>
                    <strong className="text-gray-900">Coordenadas:</strong> 20°58' N, 89°37' O
                  </p>
                </div>
              </div>
              <div className="h-80 lg:h-auto">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7649237.7544!2d-92.0!3d20.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5671f70bdfd5c3%3A0x2b5c6c1e2e8e0b15!2sYucatan!5e0!3m2!1ses!2smx!4v1234567890123!5m2!1ses!2smx"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de Yucatán"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Población */}
        <section id="poblacion" className="mb-20 scroll-mt-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Población</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Características demográficas y distribución poblacional del estado
            </p>
          </div>

          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg mb-8">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-8 lg:p-12">
                <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                  <Users className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Características Demográficas</h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Yucatán cuenta con una población de aproximadamente <strong className="text-gray-900">2.3 millones de habitantes</strong>, 
                  distribuidos en 106 municipios a lo largo de 43,379 km². El estado se caracteriza por tener una población joven 
                  y económicamente activa, con un bono demográfico favorable para el desarrollo económico.
                </p>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  La capital, Mérida, concentra más del 40% de la población total y se posiciona como el principal centro 
                  urbano, económico y cultural del sureste mexicano. La tasa de crecimiento poblacional es del 1.8% anual, 
                  ligeramente superior a la media nacional.
                </p>

                <p className="text-gray-600 leading-relaxed">
                  El 84% de la población reside en áreas urbanas, con una importante presencia de población de origen maya 
                  que mantiene vivas las tradiciones culturales y el idioma maya, hablado por aproximadamente el 30% de 
                  los habitantes del estado.
                </p>

                <div className="mt-6 grid grid-cols-2 gap-4">
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4">
                    <div className="text-2xl font-bold text-[#8B1538] mb-1">2.3M</div>
                    <div className="text-xs text-gray-600">Población Total</div>
                  </div>
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4">
                    <div className="text-2xl font-bold text-[#8B1538] mb-1">53</div>
                    <div className="text-xs text-gray-600">Hab/km²</div>
                  </div>
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4">
                    <div className="text-2xl font-bold text-[#8B1538] mb-1">84%</div>
                    <div className="text-xs text-gray-600">Población Urbana</div>
                  </div>
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4">
                    <div className="text-2xl font-bold text-[#8B1538] mb-1">1.8%</div>
                    <div className="text-xs text-gray-600">Crecimiento Anual</div>
                  </div>
                </div>
              </div>

              {/* Pirámide Poblacional */}
              <div className="bg-gradient-to-br from-slate-50 to-gray-100 p-8 lg:p-12">
                <h3 className="text-xl font-semibold text-gray-900 mb-6">Pirámide Poblacional</h3>
                
                <div className="space-y-3">
                  {/* 85+ */}
                  <div>
                    <div className="text-xs text-gray-600 mb-1">85+ años</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 flex justify-end">
                        <div className="bg-blue-400 h-6 rounded-l" style={{ width: '3%' }}></div>
                      </div>
                      <span className="text-xs font-medium w-12 text-center text-gray-700">1.5%</span>
                      <div className="flex-1">
                        <div className="bg-pink-400 h-6 rounded-r" style={{ width: '3%' }}></div>
                      </div>
                    </div>
                  </div>

                  {/* 70-84 */}
                  <div>
                    <div className="text-xs text-gray-600 mb-1">70-84 años</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 flex justify-end">
                        <div className="bg-blue-400 h-6 rounded-l" style={{ width: '8%' }}></div>
                      </div>
                      <span className="text-xs font-medium w-12 text-center text-gray-700">4%</span>
                      <div className="flex-1">
                        <div className="bg-pink-400 h-6 rounded-r" style={{ width: '8%' }}></div>
                      </div>
                    </div>
                  </div>

                  {/* 55-69 */}
                  <div>
                    <div className="text-xs text-gray-600 mb-1">55-69 años</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 flex justify-end">
                        <div className="bg-blue-400 h-6 rounded-l" style={{ width: '15%' }}></div>
                      </div>
                      <span className="text-xs font-medium w-12 text-center text-gray-700">7.5%</span>
                      <div className="flex-1">
                        <div className="bg-pink-400 h-6 rounded-r" style={{ width: '15%' }}></div>
                      </div>
                    </div>
                  </div>

                  {/* 40-54 */}
                  <div>
                    <div className="text-xs text-gray-600 mb-1">40-54 años</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 flex justify-end">
                        <div className="bg-blue-500 h-6 rounded-l" style={{ width: '30%' }}></div>
                      </div>
                      <span className="text-xs font-medium w-12 text-center text-gray-700">15%</span>
                      <div className="flex-1">
                        <div className="bg-pink-500 h-6 rounded-r" style={{ width: '30%' }}></div>
                      </div>
                    </div>
                  </div>

                  {/* 25-39 */}
                  <div>
                    <div className="text-xs text-gray-600 mb-1">25-39 años</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 flex justify-end">
                        <div className="bg-blue-600 h-6 rounded-l" style={{ width: '50%' }}></div>
                      </div>
                      <span className="text-xs font-medium w-12 text-center text-gray-700">25%</span>
                      <div className="flex-1">
                        <div className="bg-pink-600 h-6 rounded-r" style={{ width: '50%' }}></div>
                      </div>
                    </div>
                  </div>

                  {/* 15-24 */}
                  <div>
                    <div className="text-xs text-gray-600 mb-1">15-24 años</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 flex justify-end">
                        <div className="bg-blue-600 h-6 rounded-l" style={{ width: '40%' }}></div>
                      </div>
                      <span className="text-xs font-medium w-12 text-center text-gray-700">20%</span>
                      <div className="flex-1">
                        <div className="bg-pink-600 h-6 rounded-r" style={{ width: '40%' }}></div>
                      </div>
                    </div>
                  </div>

                  {/* 0-14 */}
                  <div>
                    <div className="text-xs text-gray-600 mb-1">0-14 años</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 flex justify-end">
                        <div className="bg-blue-700 h-6 rounded-l" style={{ width: '54%' }}></div>
                      </div>
                      <span className="text-xs font-medium w-12 text-center text-gray-700">27%</span>
                      <div className="flex-1">
                        <div className="bg-pink-700 h-6 rounded-r" style={{ width: '54%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-center gap-8 mt-6">
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 bg-blue-600 rounded"></div>
                    <span className="text-xs text-gray-600">Hombres (49.8%)</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 bg-pink-600 rounded"></div>
                    <span className="text-xs text-gray-600">Mujeres (50.2%)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Principales Ciudades */}
          <div className="bg-white rounded-xl p-8 border border-gray-200 shadow-lg">
            <h3 className="text-xl font-semibold text-gray-900 mb-6">Principales Ciudades</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-[#8B1538] mb-1">921,770</div>
                <div className="text-sm text-gray-600">Mérida</div>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-[#8B1538] mb-1">139,753</div>
                <div className="text-sm text-gray-600">Kanasín</div>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-[#8B1538] mb-1">85,440</div>
                <div className="text-sm text-gray-600">Valladolid</div>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-[#8B1538] mb-1">74,550</div>
                <div className="text-sm text-gray-600">Tizimín</div>
              </div>
            </div>
          </div>
        </section>

        {/* Perfil Económico */}
        <section id="perfil-economico" className="scroll-mt-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Perfil Económico</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Principales sectores económicos que impulsan el desarrollo del estado
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {sectoresEconomicos.map((sector, index) => {
              const IconComponent = sector.icono;
              return (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-xl transition-all duration-300"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center flex-shrink-0">
                      <IconComponent className="h-7 w-7 text-white" />
                    </div>
                    <div className="flex-grow">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-lg font-semibold text-gray-900">{sector.nombre}</h3>
                        <span className="text-2xl font-bold text-[#8B1538]">{sector.porcentaje}%</span>
                      </div>
                      <p className="text-sm text-gray-600 mb-3">{sector.descripcion}</p>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-gradient-to-r from-[#8B1538] to-[#6B0F2A] h-2 rounded-full" style={{ width: `${sector.porcentaje}%` }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="bg-gradient-to-br from-slate-100 to-gray-200 rounded-xl p-8 border border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Indicadores Económicos</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <div className="text-sm text-gray-600 mb-1">PIB Estatal</div>
                <div className="text-2xl font-bold text-gray-900">$458,000 MDP</div>
              </div>
              <div>
                <div className="text-sm text-gray-600 mb-1">Inversión Extranjera</div>
                <div className="text-2xl font-bold text-gray-900">$2,800 MDD</div>
              </div>
              <div>
                <div className="text-sm text-gray-600 mb-1">Tasa de Desempleo</div>
                <div className="text-2xl font-bold text-gray-900">2.8%</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PerfilYucatan;